
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";




import { GridApi, IServerSideDatasource, IServerSideGetRowsParams, RowHeightParams } from "@ag-grid-community/core";
import { GridOptions, Module } from "@ag-grid-community/core";
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import {
  MatDialog
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { filter, switchMap, takeUntil } from "rxjs/operators";
import { Subject } from 'rxjs';
import { DialogActions } from "src/app/components/dialogs/dialog.model";
import { PlanyardService } from '../../../planyard/planyard.service';
import { OrdersGridConfigService } from './../../../../data-grid/orders-grid-config.service';
import { SaveItemPayload } from '../../../../models/planyard.model';
import { InventoryService } from '../../../../services/inventory.service';
import { SideNavService } from '../../../../services/sidenav.service';
import { historyColumnDefs} from "../../../detail/detail-components/history-grid-options";
import { listingColumnDefs, listingGridOptions,} from "../../../detail/detail-components/listings-grid-options";
import { poColumnDefs,} from "../../../detail/detail-components/po's-grid-options";
import { columnDefs, gridOptions,} from "../../../detail/detail-components/vendors-grid-options";
import { SnackbarComponent } from '../../../../components/snackbar/snackbar.component';
import { ConfirmDialogComponent } from '../../../../components/dialogs/confirm-dialog/confirm-dialog.component';
import { CreateVendorItemComponent } from '../../../../components/dialogs/create-vendor-item/create-vendor-item.component';
import { MapSkuToProductComponent } from '../../../../components/dialogs/map-sku-to-product/map-sku-to-product.component';
import { ProductsGridConfigService } from '../products-grid-config.service';
import { shipmentColumnDefs } from 'src/app/modules/detail/detail-components/shipments-grid-option';
import { LogisticService } from "src/app/modules/logistic/logistic.service";
import { locationcolumnDefs } from "src/app/modules/detail/detail-components/location-grid-options";
import { WhLocationgridList_vm } from "src/app/models/warehouse.model";
import { PopupLocationSummeryComponent } from "src/app/modules/logistic/custome-component/popup-location-summery/popup-location-summery.component";
import { StorageKeyEnum } from "src/app/core/StorageKeyEnum";
import { CreateTagDialogComponent } from "src/app/modules/settings/create-tag-dialog/create-tag-dialog.component";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { SavePoPlanPayload } from "src/app/models/purchasing.model";
import { PurchasingService } from "src/app/modules/planyard/purchasing.service";
import { HeaderService } from "src/app/components/header/header.service";


@Component({
  selector: "app-product-detail-panel",
  templateUrl: "./product-detail-panel.component.html",
  styleUrls: ["./product-detail-panel.component.scss"],
})
export class ProductDetailPanelComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  private _activeTab: string;
  @Input() data;
  gridOptions: GridOptions;
  columnDefs;
  listingGridOptions: GridOptions;
  listingColumnDefs;
  modules: Module[] = [ServerSideRowModelModule];
  gridApi: GridApi;
  actions: DialogActions[];
  productId: number;
  title: string;
  product: any = {};
  apiLink;
  gridRequestParams;
  page: boolean;
  whLocationgridList_vm: WhLocationgridList_vm;
  listingGridApi: GridApi;
  isEdit: boolean = true;

  productForm: FormGroup = new FormGroup({
    name: new FormControl("", [Validators.required]),
    title: new FormControl(""),
    imageUrl: new FormControl(""),
    brand: new FormControl(""),
    model: new FormControl(""),
    color: new FormControl(""),
    upc: new FormControl(""),
    weight: new FormControl(""),
    width: new FormControl(""),
    height: new FormControl(""),
    length: new FormControl(""),
    notes: new FormControl(""),
    defaultLocation: new FormControl(""),
    totalStock: new FormControl("")
  });
  isDefaultHeight: boolean = false;
  showAddLocation: any;
  productTagsDto: any=[];
  allTags: any=[];

  get activeTab() {
    return this._activeTab;
  }
  productDetail: any;
  set activeTab(tab: string) {
    this._activeTab = tab;
    this.selectPage(this._activeTab);
  }

  availableOn: any[];
  availableChannels = {
    "Amazon": {
      url: "/assets/images/account-dropdown/amazon.png",
      width: "16px",
    },
    "Walmart": {
      url: "/assets/images/account-dropdown/walmart.png",
      width: "16px",
    },
    "Ebay": {
      url: "/assets/images/account-dropdown/ebay.png",
      width: "16px",
    }
  };
  loading:boolean=false;
  currentTab:string;
  deleteFlag = new FormControl();
  IsDeletedPo = new FormControl();
  constructor(
    private planyardService: PlanyardService,
    private inventoryService: InventoryService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private sideNavService: SideNavService,
    private productsGridConfigService: ProductsGridConfigService,
    private ordersGridConfigService: OrdersGridConfigService,
    private logisticsService: LogisticService,
    private shipyardService: ShipyardService,
    private purchasingService:PurchasingService,
    private router:Router,
    private headerService:HeaderService
  ) { }

  ngOnInit(): void {
    this.productForm.disable({emitEvent: false});
    if (this.route.snapshot.params["product"]) {
      this.page = true;
      this.data = {
        ItemId: this.route.snapshot.params["product"],
      };
    }
    if (this.data) {
      this.getTags();
      this.loadProduct(this.data.ItemId);
      this.title = `Edit Product ${this.data.ItemId}`;
      if(this.data?.redirectToBasicInfo)
       this.activeTab = "Basic info";
      else if(localStorage.getItem(StorageKeyEnum.selectedTab))
       this.activeTab = localStorage.getItem(StorageKeyEnum.selectedTab);
      else
      this.activeTab = "Dashboard";
    } else {
      this.title = "New Product";
    }

    const productNameInput = this.productForm.get("name");

    this.productForm.get("name").valueChanges
      .pipe(
        takeUntil(this.destroy$),
        filter((res)=>!this.product || this.product.name !== productNameInput.value),
        switchMap((e) => this.planyardService.ProductExists(e.trim()))
      )
      .subscribe((e) => {
        if (e) {
          if (!this.product || this.product.name !== productNameInput.value) {
            productNameInput.setErrors({ unique: true });
          }
        } else {
          productNameInput.setErrors(null);
        }
      });
  }

  ngOnDestroy(): void {
    this.close('products') 
    this.destroy$.next();
    this.destroy$.unsubscribe();
    localStorage.removeItem('selectedTab');
  }

  loadProduct(id) {
    this.planyardService.GetProductDetails(id).pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
      this.availableOn = e.availableOn;
      this.productId = e.id;
      this.productDetail= e;
      this.productTagsDto=e.getProductTagsDto;
      this.allTags.forEach((res,i) => {
      let index = this.productTagsDto.findIndex((el) => el.tagId == res.tagId);
       if (index !== -1) this.allTags[i].hide = true;      
      })
      this.allTags = this.allTags.filter((res)=> !res?.hide);
      this.fillForm(e);
      this.title = e.name;
      this.product = e;
      this.deleteFlag.setValue(!e.deleteFlag);
    });
  }

  saveProduct(isEdit = false) {
    if(isEdit) this.loading=true;
    const payload: SaveItemPayload = {
      ...this.productForm.value,
      name: this.productForm.value.name.trim(),
      length: +this.productForm.value.length,
      height: +this.productForm.value.height,
      width: +this.productForm.value.width,
      weight: +this.productForm.value.weight,
      totalStock: +this.productForm.value.totalStock,
      vendorItems: [],
      deleteFlag: !this.deleteFlag.value
    };
    if (this.productId) {
      payload["id"] = this.productId;
    }

    this.planyardService.SaveItem(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (e) => {
      this.loading=false;
      this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Product saved successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
      );
      if (this.productId) {
        this.product.name = this.productForm.get("name").value;
        this.productsGridConfigService.refreshServerSide();
        this.isEdit = true;
        this.productForm.disable({ emitEvent: false });
      } else {
        this.loadProduct(e);
      }
    },
     error: (err) => {
      this.loading=false;
      this.deleteFlag.setValue(!this.productDetail.deleteFlag);
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
    );
     }
    });
  }

  fillForm(e) {
    this.productForm.patchValue(e, { emitEvent: false });
  }

  tabClicked(e) {
    this.activeTab = e;
    localStorage.setItem(StorageKeyEnum.selectedTab, e);  
  }

  selectPage(page) {
    this.gridOptions = gridOptions;
    const body=this.gridRequestParams && this.currentTab === page ? this.gridRequestParams : { startRow: 0, endRow: 20 };
    let skuIds;
    if (this.product) {
      skuIds = this.product?.accountSkuIds
        ? this.product.accountSkuIds.split(",").map(Number)
        : [];
    }
    if (page == "Basic info") {
      const itemsColumns = [...columnDefs, ...[{
        field: "",
        headerName: '',
        width: 80,
        cellRenderer: "actionsComponent",
        cellRendererParams: {
          edit: (params) => this.editItem(params),
          delete: (params) => this.deleteItem(params),
        },
      }]];
      this.columnDefs = itemsColumns;
      const filter = {
        ItemId: {
          filterType: "number",
          type: "in",
          intValues: [this.productId],
        },
        DeleteFlag: {
          filterType: "boolean",
          value: false,
        },
      }
      this.apiLink = this.planyardService.GetProductsItemsList(
        body,
        this.columnDefs,
        filter
      );

      this.listingGridOptions = listingGridOptions;
      const listingColumns = [...listingColumnDefs, ...[{
        field: "Actions",
        headerName: '',
        width: 80,
        cellRenderer: "actionsComponent",
        cellRendererParams: {
          edit: (params) => this.editMapping(params),
        },
      }]];
      this.listingColumnDefs = listingColumns;
    } else if (page === "Orders") {
      this.columnDefs = this.ordersGridConfigService.orderColumnDefs;
      this.apiLink = this.planyardService.GetProductsOrderList(
        body,
        this.columnDefs,
        skuIds
      );
    } else if (page === "Stock") {
      const locationColumns = [...locationcolumnDefs, ...[{
        field: "",
        headerName: '',
        width: 80,
        cellRenderer: "actionsComponent",
        cellRendererParams: {
          edit: (params) => this.editlocationItemSummery(params),
        },
      }]];
      this.columnDefs = locationColumns;
      this.headerService.updatedSetting.pipe(takeUntil(this.destroy$)).subscribe((res)=>{
        if( this.headerService.useBinLocation){
          let idx =  this.columnDefs.findIndex((res)=> res.field == 'LocationCode');
          if(idx !== -1){
            this.columnDefs.splice(idx,1);
          }
          this.columnDefs.splice(2,0,
            {
              field: "LocationCode",
              headerName: "Location Code",
              headerTooltip: "Location Code",
              backendFields: ["LocationCode"],
              sortable: true,
              filter: "agTextColumnFilter",
              width: 150,
            }
          )
        }else{
          let idx =  this.columnDefs.findIndex((res)=> res.field == 'LocationCode');
          if(idx !== -1){
            this.columnDefs.splice(idx,1);
          }
        } 
        this.gridApi?.setGridOption('columnDefs', this.columnDefs);     
      });
    } else if (page === "History") {
      this.columnDefs = historyColumnDefs;
      this.apiLink = this.logisticsService.GetAllHistoryList(
        body,
        this.columnDefs,
        null,
        this.productId
      );
    } else if (page === "Purchase Orders") {
      this.columnDefs = poColumnDefs;
      this.apiLink = this.inventoryService.GetProductPos(this.productId,this.IsDeletedPo.value)
    } else if (page === "Shipments") {
      this.columnDefs = shipmentColumnDefs;
      const filterModel = {
        ItemId: {filterType: "number", type: "equals",filter: this.productId}
      }
      this.apiLink = this.inventoryService.GetProductShipmentList(
        body,
        this.columnDefs,
        filterModel
      );
    }
    else if (page === "Dashboard" || page === "Stock" || page === "Daily snapshots") {
      this.gridOptions = null;
      this.columnDefs = null;
      this.apiLink = null;
    }
    if(this.currentTab !== page){
      this.currentTab=page;
      this.gridApi?.refreshServerSide({ route: [], purge: true });
    }    
  }
  editlocationItemSummery(params: any) {
    this.whLocationgridList_vm = new WhLocationgridList_vm();
    this.whLocationgridList_vm.LocationCode = params.data.LocationCode;
    this.whLocationgridList_vm.WarehouseId = params.data.WarehouseId;
    this.whLocationgridList_vm.locationid = params.data.LocationId;
    this.whLocationgridList_vm.itemId = this.productId;
    this.whLocationgridList_vm.itemName = this.productDetail.name;
    this.whLocationgridList_vm.locationSummaryId =
      params.data.LocationSummaryId;
    this.whLocationgridList_vm.qty = params.data.Qty;
    this.whLocationgridList_vm.isProductdisable = 1;
    var data: any = this.whLocationgridList_vm;
    if(this.headerService.useBinLocation){
      data.title = 'Edit Warehouse Qty'
    }else{
      data.title = "Adjust Stock Qty";
    }
    this.dialog
      .open(PopupLocationSummeryComponent, {
        width: "335px",
        data,
      })
      .afterClosed()
      .pipe(filter((e:any) => e))
      .subscribe((e) => {
        this.gridApi.refreshServerSide({ purge: true })  
      });
  }

  addLocation(){
    this.whLocationgridList_vm = new WhLocationgridList_vm();
    this.whLocationgridList_vm.itemId = this.productId,
    this.whLocationgridList_vm.itemName= this.productDetail.name,
    this.whLocationgridList_vm.isProductdisable = 1;
    var data:any = this.whLocationgridList_vm;
    data.title = "Add New Warehouse Qty";
    this.dialog
    .open(PopupLocationSummeryComponent, {
      width: "335px",
      data,
    })
    .afterClosed()
    .pipe(filter((e:any) => e))
    .subscribe((e) => {
      this.gridApi.refreshServerSide({ purge: true })
    });
  }

  deletelocationItemSummery(params: any) {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
         title: "Delete Item From warehouse",
          message: `Are you sure you want to remove this warehouse and its stock?`,
          actions: [
            { text: "Cancel", buttonStyle: "underline" },
            { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
          ],
          confirmationButton: "Confirm",
          callBackFn: (dialogRef, actions) => {
          const payload = {
            locationSummaryId:params.data.LocationSummaryId,
            action :"Delete location from item "+this.productDetail.name
          }
        this.logisticsService
          .DeleteWhLocationSummery(payload).pipe(takeUntil(this.destroy$))
          .subscribe({
           next: (res) => {
            if (dialogRef) {
              dialogRef.close();
            }
            if (actions) {
              actions[1].spin = false;
            }
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Warehouse stock deleted successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
            this.gridApi.refreshServerSide({ purge: true });
          },
         error: (err) => {
            if (dialogRef) {
              dialogRef.close();
            }
            if (actions) {
              actions[1].spin = false;
            }
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: err.error.error[0],
                  action: 'Dismiss',
                  type: 'error',
                },
              }
            )
           }
          });
        }
      },
    })
  }
  getRowHeight(params: RowHeightParams) {
    if(params.data){
      var rowHeight = 0
      if (params.data.hasOwnProperty('Orderid') || params.data.hasOwnProperty('ShipmentId') || params.data.hasOwnProperty('VendorName')) {
        rowHeight = 58;
      } else {
        rowHeight = 42;
      }
      return rowHeight;
    }
    
  }

  gridReady(event) {
    this.gridApi = event.api;
    this.gridApi.setGridOption("serverSideDatasource", this.vendorDataSource);
    this.gridApi.sizeColumnsToFit();
  }

  determineHeight(length = 0) {
    if (length < 5 && this._activeTab === "Basic info") {
      this.gridApi.setGridOption("domLayout", "autoHeight");
      this.isDefaultHeight = true;
    }
    else {
      this.gridApi.setGridOption("domLayout", "normal");
      this.isDefaultHeight = false;
    }
  }

  listingGridReady(event) {
    this.listingGridApi = event.api;
    this.listingGridApi.setGridOption("serverSideDatasource", this.listingDataSource);
    this.listingGridApi.sizeColumnsToFit();
  }

  close(page?) {
    this.shipyardService.isTagAdded = true;
    this.sideNavService.close(page);
  }

  edit() {
    this.isEdit = false;
    this.productForm.enable({ emitEvent: false })
  }

  cancel(){
    this.isEdit = true;
    this.productForm.disable({ emitEvent: false })
    this.fillForm(this.productDetail);
  }

  listingDataSource: IServerSideDatasource = {
    getRows: (params: IServerSideGetRowsParams) => {
      this.gridRequestParams = params.request;
      this.planyardService.GetProductMappings(this.data.ItemId).pipe(takeUntil(this.destroy$)).subscribe({
        next: (response: any) => {
          if (response) {
            if (response.length === 0) {
              this.listingGridApi.showNoRowsOverlay();
            } else {
              this.listingGridApi.hideOverlay();
            }
            params.success({
              rowData: response,
              rowCount: response.length,
            });
            this.listingGridApi.sizeColumnsToFit();
          }
        },
       error: (err) => {
        params.fail()
       }
     });
    },
  };

  vendorDataSource: IServerSideDatasource = {
    getRows: (params: IServerSideGetRowsParams) => {
      this.gridRequestParams = params.request;
      this.selectPage(this.currentTab);
      if (this.activeTab === 'Stock') {
        const payload = {
          itemId: this.productId,
          startRow: this.gridRequestParams.startRow,
          endRow: this.gridRequestParams.endRow
        }
        this.apiLink = this.logisticsService.GetWhLocationListforproduct(payload);
      }
      this.apiLink?.pipe(takeUntil(this.destroy$)).subscribe(
        (response: any) => {
          if (response) {
            this.showAddLocation = response
            if (this._activeTab == "Purchase Orders") {
            /*  response.forEach((el) => {
                if (el.poNumber == el.poInvoiceNumber) {
                  el.poInvoiceNumber = null;
                }
              });*/
              if (!response.length) {
                this.gridApi.showNoRowsOverlay();
              } else {
                this.gridApi.hideOverlay();
              }
              params.success({
                rowData: response,
                rowCount: response.length,
              });
            } else {
              if (!response.totalCount) {
                this.gridApi.showNoRowsOverlay();
              } else {
                this.gridApi.hideOverlay();
              }
              params.success({
                rowData: response.data,
                rowCount: response.totalCount,
              });
            }
            this.gridApi.sizeColumnsToFit();
          }
        },
        () => params.fail()
      );
    },
  };

  updateImage() {
    const value = this.productForm.get("imageUrl").value;

    if (value) {
      this.product.imageUrl = value;
    }
  }

  editLocation(params) {

  }

  deleteLocation(params) {

  }

  editItem(params): void {
    this.dialog
      .open(CreateVendorItemComponent, {
        width: "700px",
        disableClose: true,
        panelClass: "dialog-container-custom",
        data: {
          productId: params.data.ItemId,
          vendorItem: params.data,
        },
      })
      .afterClosed()
      .pipe(filter((e:any) => e))
      .subscribe((e) => this.gridApi.refreshServerSide({ purge: true }));
  }

  deleteItem(params): void {
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "500px",
        data: {
          title: "Delete Vendor Item",
          message: `Are you sure you want to remove ${params.node.data.VendorItemName} from this Product?`,
          warning: `<i class="far fa-exclamation-triangle me-2"></i>Note: If the item is on a PO, it will be archived, not deleted`,
        }
      })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.inventoryService.RemoveVendorItem(params.data.ItemVendorId).pipe(takeUntil(this.destroy$)).subscribe(() => {
          this.snackBar.openFromComponent(SnackbarComponent,
            {
              duration: 4000,
              horizontalPosition: 'center',
              data: {
                title: 'Vendor Item removed successfully',
                action: 'Dismiss',
                type: 'error',
              },
            }
        );
          this.gridApi.refreshServerSide({ purge: true });
        })
      })
  }

  editMapping(params: any): void {
    this.dialog
      .open(MapSkuToProductComponent, {
        width: "700px",
        panelClass: "dialog-container-custom",
        data: {
          sku: params.data,
          confirmationButton: "Confirm",
          callBackFn: (dialogRef, e, actions,isActive) => {
            let api = !isActive ? this.inventoryService.setItemMapping(e) : this.planyardService.SetSkuMapping(e)
            api.pipe(takeUntil(this.destroy$)).subscribe({
            next: (res) => {
              if (dialogRef) {
                dialogRef.close();
              }
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 4000,
                  horizontalPosition: 'center',
                  data: {
                    title: "Item mapping updated successfully",
                    action: 'Dismiss',
                    type: 'success',
                  },
                }
            );
              this.listingGridApi.refreshServerSide({ purge: true })
            },
             error: (err) => {
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 4000,
                  horizontalPosition: 'center',
                  data: {
                    title: err.error?.error[0],
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
              },
             complete:()=>{
              if (dialogRef) {
                dialogRef.close();
               }
             }
            }
           );
          }
        }
       
      })
      .afterClosed()
      .pipe(filter((e:any) => e))
      .subscribe();
  }

  newVendorItem() {
    this.dialog
      .open(CreateVendorItemComponent, {
        width: "1000px",
        disableClose: true,
        panelClass: "dialog-container-custom",
        data: {
          productId: this.productId,
        },
      })
      .afterClosed()
      .pipe(filter((e:any) => e))
      .subscribe((e) => {
        this.gridApi.refreshServerSide({ purge: true });
      });
  }

  newMapping() {
    this.dialog
      .open(MapSkuToProductComponent, {
        width: "700px",
        panelClass: "dialog-container-custom",
        data: {
          product: {
            ItemId: this.product.id,
            Name: this.product.name,
          },
          callBackFn: (dialogRef, e, actions,isActive) => {
            let api = isActive ? this.planyardService.SetSkuMapping(e) : this.inventoryService.setItemMapping(e);
            api.pipe(takeUntil(this.destroy$)).subscribe({
            next: (res) => {
              if (dialogRef) {
                dialogRef.close();
              }
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 3000,
                  horizontalPosition: 'center',
                  data: {
                    title: "Item mapping saved successfully",
                    action: 'Dismiss',
                    type: 'success',
                  },
                }
            );
              this.listingGridApi.refreshServerSide({ purge: true })
            },
             error: (err) => {
              if (actions) {
                actions[1].spin = false;
              }
              this.snackBar.openFromComponent(SnackbarComponent,
                {
                  duration: 4000,
                  horizontalPosition: 'center',
                  data: {
                    title: err.error?.error[0],
                    action: 'Dismiss',
                    type: 'error',
                  },
                }
            );
            },
             complete:() =>{
              if (dialogRef) {
                dialogRef.close();
              }
            }
             });
          }
        },
      })
      .afterClosed()
      .pipe(filter((e:any) => e))
      .subscribe();
  }

  onChange(event) {
    let msg 
    if(this.productDetail.isInPo ){
      msg = 'This item  exists in Po. '
    }
    if(this.productDetail.IsMapped ){
      msg = 'This item  is Mapped to SKu '
    }
    this.dialog
      .open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: event.checked ? 'Activate' : 'Deactivate',
          message: `${!event.checked ? msg : ''}` + `Are you sure you want to ${event.checked ? 'activate' : 'deactivate'}?`,
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res === "Confirm") {
          this.saveProduct();
        }
        else {
            this.deleteFlag.setValue(!this.productDetail.deleteFlag);
        }
      })
   }

   openAllTag(e:MouseEvent) {
    this.dialog.open(CreateTagDialogComponent, {
      backdropClass: "cdk-overlay-transparent-backdrop",
       position: this.getDialogRightPosition(e),
      data: {
        tag: this.allTags,
        title: "Add Tags in Product",
        isProductTag:true,
        itemID: this.productId,
        isTags:true
      }
    }).afterClosed()
    .pipe(filter((res) => res === "save"))
    .subscribe({
      next: () => {
        this.getTags();
        this.loadProduct(this.productId);
      },
    });
  }

  getDialogRightPosition(e: MouseEvent) {
    const target = e.target as any;
    const targetPosision = target.getBoundingClientRect();
    return {
      bottom: targetPosision +500 +"px",
      left: targetPosision.left + "px",
      right: targetPosision.right + 150+"px",
      top: targetPosision.top +22+ "px",
    };  
 }

  deleteTag(tagId) {
    let payload = {
      itemID: this.productId,
      tagId: [tagId]
    }
    this.dialog.open(ConfirmDialogComponent, {
        width: "600px",
        data: {
          title: "Delete Tag",
          message: "Are you sure you want to delete this Tag?",
        },
      }) .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe(() => {
        this.inventoryService.DeleteTagInProduct(payload).pipe(takeUntil(this.destroy$)).subscribe({
          next: (data) => {
            this.getTags();
            this.loadProduct(this.productId);
            this.snackBar.openFromComponent(SnackbarComponent,
              {
                duration: 3000,
                horizontalPosition: 'center',
                data: {
                  title: 'Tag deleted successfully',
                  action: 'Dismiss',
                  type: 'success',
                },
              }
            );
          },
        });
      });
  }
  
  getTags() {
    this.inventoryService.GetTags().pipe(takeUntil(this.destroy$)).subscribe({
    next: (data: any) => {
      if (data) {
        this.allTags = data;
      }
    },
    error: (error) => {
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: error.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        });
     }
    });
  }


  newPo(){
    const itemQtyList = [{
      itemId: this.productId,
      qty:  1,
    }]

    const payload: SavePoPlanPayload = {
      itemQtyList,
    };

    this.purchasingService.SavePoPlan(payload).subscribe((e) => {
      this.router.navigate(["forecasting/po-plan", e])
    });
  }



  onChangeToggle(event){
    if(event){
     this.IsDeletedPo.setValue(event.checked);
      this.gridApi.refreshServerSide({ purge: true });
    }
  }
}

